import styled from 'styled-components';
import { sizes } from 'style';
import Container from 'components/Container';

export const TeamPageWrapper = styled(Container)`
  padding-top: 70px;
  font-family: 'Helvetica Now', Arial, sans-serif;

  @media ${sizes.desktop} {
    padding-top: 90px;
  }
`;

export const Breadcrumbs = styled.div`
  display: none;
  margin-bottom: 24px;
  margin-top: 12px;
  font-size: 14px;

  > * {
    cursor: pointer;

    :hover {
      opacity: 0.8;
    }
  }

  @media ${sizes.tabletPortrait} {
    display: block;
  }
`;

export const JoinOurTeam = styled.p`
  font-size: 16px;
  margin-top: 80px;
  display: none;

  @media ${sizes.tabletPortrait} {
    display: block;
  }
`;

export const MembersList = styled.div`
  margin-top: 24px;

  > *:not(:last-child) {
    margin-bottom: 32px;
  }

  @media ${sizes.tabletPortrait} {
    display: none;
  }
`;
